import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { baseApi } from '@ibk/shared-config';
import { mapPostTransferPixPixBodyToTransferPixV3Api } from '../../hooks/useMapPostTransferPixV3';
export const pixApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        postTransferPix: builder.mutation({
            query: ({ body, transactionIdempotencyId, usePermissions }) => {
                let url = '/v2/transfer/pix';
                if (usePermissions) {
                    url += '?usePermissions=true';
                }
                return {
                    url,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    transactionIdempotencyId,
                };
            },
        }),
        postTransferPixV3: builder.mutation({
            query: ({ body, transactionIdempotencyId, usePermissions }) => {
                let url = '/v3/transfer/pix';
                if (usePermissions) {
                    url += '?usePermissions=true';
                }
                return {
                    url,
                    method: 'POST',
                    body: mapPostTransferPixPixBodyToTransferPixV3Api(body),
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    transactionIdempotencyId,
                };
            },
        }),
        postSchedulePix: builder.mutation({
            query: ({ body, transactionIdempotencyId, usePermissions }) => {
                let url = '/v1/schedule/pix';
                if (usePermissions) {
                    url += '?usePermissions=true';
                }
                return {
                    url,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    transactionIdempotencyId,
                };
            },
        }),
        postPixAgencyAccount: builder.mutation({
            query: ({ body, transactionIdempotencyId, usePermissions }) => {
                let url = '/v1/pix/pixout/branch-agency';
                if (usePermissions) {
                    url += '?usePermissions=true';
                }
                return {
                    url,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    transactionIdempotencyId,
                };
            },
        }),
        postPixAgencyAccountV2: builder.mutation({
            query: ({ body, transactionIdempotencyId, usePermissions }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                let url = '/v2/pix/pixout/branch-agency';
                if (usePermissions) {
                    url += '?usePermissions=true';
                }
                return {
                    url,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    transactionIdempotencyId,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
        postValidateDuplicate: builder.mutation({
            query: ({ body }) => {
                return {
                    url: '/v2/transfer/validate-duplicate',
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                };
            },
        }),
        postTransferPixBatch: builder.mutation({
            query: ({ body, transactionIdempotencyId, usePermissions }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                let url = '/v1/transfer/pix/batch';
                if (usePermissions) {
                    url += '?usePermissions=true';
                }
                return {
                    url,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    transactionIdempotencyId,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
    }),
});
export const { usePostTransferPixMutation, usePostTransferPixV3Mutation, usePostSchedulePixMutation, usePostPixAgencyAccountMutation, usePostPixAgencyAccountV2Mutation, usePostValidateDuplicateMutation, usePostTransferPixBatchMutation, } = pixApi;
